var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app2"}},[(_vm.showed)?_c('fbx-viewer',{ref:"model",attrs:{"type":_vm.type,"url":_vm.urled}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }